import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import {
  Box,
  TextField,
  MenuItem,
  Typography,
  Tooltip,
  CircularProgress,
} from '@material-ui/core'

import useStyles from './styles'

const Select = ({
  items,
  fieldName = 'name',
  fieldValue = 'id',
  anotherOption = false,
  anotherText = false,
  isLoading = false,
  noWrap = false,
  disabledItems = [],
  placeholder,
  SelectProps: selectPropsProp,
  ...rest
}) => {
  const classes = useStyles()

  return (
    <Box position="relative" width="100%">
      <TextField
        select
        fullWidth
        variant="outlined"
        disabled={isLoading}
        SelectProps={{
          displayEmpty: !!placeholder,
          ...selectPropsProp,
        }}
        {...rest}
      >
        {placeholder && (
          <MenuItem value="" disabled>
            <Typography color="textSecondary">{placeholder}</Typography>
          </MenuItem>
        )}
        {items?.map((item, index) => (
          <MenuItem
            key={index}
            value={item?.[fieldValue]}
            disabled={disabledItems.includes(item?.[fieldValue])}
          >
            <Box width="100%">
              <Tooltip title={item?.[fieldName] || ''} placement="top">
                <Typography
                  className={clsx({
                    [classes.noWrap]: noWrap,
                    [classes.wrap]: !noWrap,
                  })}
                >
                  {item?.[fieldName] || ''}
                </Typography>
              </Tooltip>
            </Box>
          </MenuItem>
        ))}
        {anotherOption && (
          <MenuItem key="another" value="another">
            {anotherText ? 'Outra' : 'Outro'}
          </MenuItem>
        )}
      </TextField>
      {isLoading && (
        <Box
          position="absolute"
          top={12}
          right={40}
          display="flex"
          alignItems="center"
        >
          <CircularProgress size={24} />
        </Box>
      )}
    </Box>
  )
}

Select.propTypes = {
  items: PropTypes.array.isRequired,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.string,
  anotherOption: PropTypes.bool,
  anotherText: PropTypes.bool,
  isLoading: PropTypes.bool,
  noWrap: PropTypes.bool,
  disabledItems: PropTypes.array,
  placeholder: PropTypes.string,
  SelectProps: PropTypes.object,
}

export default Select
